module.exports = __webpack_public_path__ + "img/fidelity.cfe128dd.svg";